import api, { getResponseError } from '../../services/api';
import { IResponse, IErrorResponse } from '../types/ErrorResponse';
import { TCommunityMemberPagination } from '../types/CommunityMember';
import { ExportFileTypeEnum } from './ReportDownloadController';

interface IGetMembersProp {
  productId: string;
  page: number;
  rows: number;
  name?: string;
  hasJoined?: boolean | null;
}

const getMembers = async ({
  productId,
  page,
  rows,
  name,
  hasJoined,
}: IGetMembersProp): Promise<TCommunityMemberPagination | IErrorResponse> => {
  try {
    let path = `/CommunityIntegration/members?productId=${productId}&pageNumber=${page}&rowsPerPage=${rows}`;

    if (name && name !== '') {
      path += `&name=${encodeURIComponent(name)}`;
    }
    if (hasJoined !== null && hasJoined !== undefined) {
      path += `&hasJoined=${hasJoined}`;
    }

    const { data } = await api.get<TCommunityMemberPagination>(path);
    if (data) return data;
    return { code: 1, error: 'Erro inesperado do servidor' };
  } catch (error) {
    const e = getResponseError(error);
    return { code: 2, error: e };
  }
};

const renewTelegramInviteLink = async (orderId: string, productPriceId?: string): Promise<IResponse> => {
  try {
    const data = { orderId, productPriceId};
    const response  = await api.put(`/CommunityIntegration/telegram/renew/inviteLink`, data);

    if (response.status >= 200 && response.status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
        data: response.data as string,
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

interface IMemberActionProp {
  memberId: string;
}

const removeMember = async ({
  memberId,
}: IMemberActionProp): Promise<IResponse> => {
  try {
    await api.post(`/CommunityIntegration/members/${memberId}/remove`);
    return { success: true, code: 0, error: '' };
  } catch (error) {
    const e = getResponseError(error);
    return { success: false, code: 2, error: e };
  }
};

const resendEmail = async ({
  memberId,
}: IMemberActionProp): Promise<IResponse> => {
  try {
    await api.post(`/CommunityIntegration/members/${memberId}/resend-email`);
    return { success: true, code: 0, error: '' };
  } catch (error) {
    const e = getResponseError(error);
    return { success: false, code: 2, error: e };
  }
};

interface IGetMembersFileProp {
  productId: string;
  name?: string;
  hasJoined?: boolean | null;
  exportFileType: ExportFileTypeEnum;
}

const getMembersFile = async ({
  productId,
  name,
  hasJoined,
  exportFileType,
}: IGetMembersFileProp): Promise<Blob | IErrorResponse> => {
  try {
    let path = `/CommunityIntegration/members/file?productId=${productId}&exportFileType=${exportFileType}`;

    if (name && name !== '') {
      path += `&name=${encodeURIComponent(name)}`;
    }
    if (hasJoined !== null && hasJoined !== undefined) {
      path += `&hasJoined=${hasJoined}`;
    }

    const { data } = await api.get<Blob>(path, {
      responseType: 'blob',
      headers: {
        Accept:
          exportFileType === ExportFileTypeEnum.XLS
            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            : 'text/csv',
      },
    });
    if (data) return data;
    return { code: 1, error: 'Erro inesperado do servidor' };
  } catch (error) {
    const e = getResponseError(error);
    return { code: 2, error: e };
  }
};

const CommunityIntegrationController = {
    renewTelegramInviteLink,
    getMembers,
    removeMember,
    resendEmail,
    getMembersFile,
};

export default CommunityIntegrationController;
